export const bosses = [
  {
    id: "inspecteur",
    name: "L'Inspecteur du Fisc",
    emoji: "\ud83d\udd75\ufe0f",
    title: "Boss 1 -- Direction Generale des Finances Publiques",
    description: "Il a trouve une anomalie dans ta declaration de 2019. Il sourit pas.",
    hp: 150, maxHp: 150,
    atk: 12, def: 8,
    attacks: [
      {
        name: "Contrôle fiscal",
        damage: 15,
        emoji: "🔍",
        message: "L'inspecteur épluche tes relevés bancaires...",
        reactions: {
          attack: "Ton attaque l'agace, mais il continue d'éplucher tes relevés ligne par ligne. Année par année.",
          defense: "Tu te caches derrière tes papiers — il sourit et coche une case dans son tableau Excel.",
          heal: "Pendant que tu reprends des forces, lui prend des notes. Beaucoup de notes. Sur toi.",
          item: "Il te regarde fouiller dans ton sac : « Ah, vous avez aussi ÇA dans votre déclaration ? Intéressant. »",
        },
      },
      {
        name: "Redressement",
        damage: 25,
        emoji: "📊",
        message: "CRITIQUE ! Un redressement fiscal de 3 ans !",
        isCrit: true,
        chance: 0.25,
        reactions: {
          attack: "CRITIQUE ! Tu attaques de front — il dégaine son tampon « REDRESSEMENT 3 ANS » avant que tu finisses ta phrase.",
          defense: "CRITIQUE ! Il perce ta défense en trois coups de calculatrice. Trois ans de redressement, en bloc.",
          heal: "CRITIQUE ! Tes soins n'ont aucun effet. Le redressement, lui, est rétroactif.",
        },
      },
      {
        name: "Mise en demeure",
        damage: 10,
        emoji: "📬",
        message: "Un courrier recommandé arrive... ta luck baisse.",
        effect: { type: "debuff_luck", value: 3 },
        reactions: {
          attack: "Ton attaque le pousse à dégainer son arme préférée : un courrier en LRAR. Ta chance s'évapore.",
          defense: "Il esquive ta défense en signant une mise en demeure. Tu sens la malchance s'installer.",
          heal: "Tu te soignes. Il t'envoie une LRAR. Le bonheur est éphémère.",
        },
      },
    ],
    introDiag: "Bonjour. Asseyez-vous. J'ai quelques... questions concernant vos revenus.",
    defeatDiag: "Impossible... mes tableaux Excel etaient parfaits !",
    loot: { name: "Avis de Non-Imposition", emoji: "\ud83d\udcc4", image: "/images/items/loot_inspecteur.png", effect: "atk", value: 3, desc: "+3 ATK -- La preuve que tu gagnes rien" },
    color: "slate"
  },
  {
    id: "dame_accueil",
    name: "La Dame de l'Accueil",
    emoji: "\ud83d\ude24",
    title: "Boss 2 -- Guichet 7 (Ferme pour pause)",
    description: "Elle est la depuis 1987. Elle a vu des choses. Elle juge.",
    hp: 140, maxHp: 140,
    atk: 10, def: 10,
    attacks: [
      {
        name: "Regard désapprobateur",
        damage: 12,
        emoji: "👀",
        message: "Elle te fixe par-dessus ses lunettes...",
        reactions: {
          attack: "Tu hausses la voix. Elle baisse ses lunettes. Le silence qui suit fait plus mal qu'un coup.",
          defense: "Tu te recroquevilles derrière tes papiers. Elle te regarde comme une assurance scolaire mal remplie.",
          heal: "Tu reprends des forces. Elle soupire avec un mépris si pur qu'il pourrait être primé.",
          item: "Tu sors un objet de ton sac. Elle te suit du regard, sourcil arqué. Tu as perdu deux points de dignité.",
        },
      },
      {
        name: "« Vous avez pas le bon formulaire »",
        damage: 18,
        emoji: "📋",
        message: "Tu perds un tour à chercher le Cerfa 12345*02.",
        effect: { type: "skip_turn" },
        reactions: {
          attack: "Tu attaques. Elle pose un papier devant toi : « Cerfa 12345*02. Pas le 12345*01. Allez le chercher. »",
          defense: "Tu te défends. Elle pointe ton dossier : « Il manque l'annexe B-bis. C'est verso impair. Revenez. »",
          heal: "Tu te soignes. Elle attend, patiente. Puis : « Ce formulaire date de 2018. On accepte la version 2019. »",
        },
      },
      {
        name: "« Revenez lundi »",
        damage: 0,
        emoji: "🚪",
        message: "Elle se soigne en fermant son guichet.",
        effect: { type: "self_heal", value: 12 },
        condition: { type: "hp_below", value: 0.65 },
        reactions: {
          attack: "Tu attaques fort. Elle baisse le rideau métallique du guichet. Pause syndicale d'urgence. Elle reprend un peu de souffle.",
          defense: "Tu te défends. Elle en profite pour boire un verre d'eau — réglementaire — et grappiller quelques HP.",
          heal: "Tu te soignes. Elle aussi. Grâce à toi, le guichet ferme exceptionnellement à 16h30.",
        },
      },
      {
        name: "Pause café prolongée",
        damage: 0,
        emoji: "☕",
        message: "Pause réglementaire de 15 minutes.",
        effect: { type: "self_heal", value: 18 },
        condition: { type: "hp_below", value: 0.4 },
        reactions: {
          attack: "Tu cognes fort. Elle invoque la convention collective et s'effondre dans son fauteuil. Café d'urgence.",
          defense: "Tu te défends. Elle bâille, atteint ses limites. Décroche : « Allô Janine ? Pause au 7. »",
          heal: "Tu te soignes. Elle aussi, désespérée : un café noir, un éclair au chocolat, dix minutes de Facebook.",
        },
      },
    ],
    introDiag: "C'est pour quoi ? ... *soupir* ... Vous avez pris un ticket ?",
    defeatDiag: "Mais... c'est l'heure de ma pause !",
    loot: { name: "Ticket Prioritaire", emoji: "\ud83c\udfab", image: "/images/items/loot_dame_accueil.png", effect: "def", value: 5, desc: "+5 DEF -- Tu passes devant tout le monde" },
    color: "rose"
  },
  {
    id: "bug_info",
    name: "Le Bug Informatique",
    emoji: "\ud83d\udda5\ufe0f",
    title: "Boss 3 -- Erreur 500 : Service Temporairement Indisponible",
    description: "Le serveur de la CAF tourne sous Windows XP. Il crashe par solidarite.",
    hp: 180, maxHp: 180,
    atk: 14, def: 6,
    attacks: [
      {
        name: "404 Dossier Not Found",
        damage: 16,
        emoji: "❌",
        message: "Votre dossier n'existe pas. Réessayez.",
        reactions: {
          attack: "Tu frappes le serveur. Il te répond : « Dossier introuvable. Veuillez vérifier votre identité. »",
          defense: "Tu te protèges. L'écran clignote : « Session expirée — vous n'existez plus. »",
          heal: "Tu te soignes. La page se recharge. Tu es déconnecté. Reconnecte-toi pour exister.",
        },
      },
      {
        name: "Boucle infinie",
        damage: 8,
        emoji: "🔄",
        message: "Vous êtes redirigé vers la page de connexion... encore.",
        effect: { type: "dot", value: 8, turns: 3 },
        reactions: {
          attack: "Tu attaques. La page tourne. Tourne. Tu retombes sur le même formulaire que tout à l'heure.",
          defense: "Tu te défends. Il t'enferme dans un cycle : connexion → captcha → erreur → connexion → captcha → erreur.",
          heal: "Tu te soignes. La barre de progression bloque à 87%. Pour toujours.",
        },
      },
      {
        name: "Mise à jour du système",
        damage: 0,
        emoji: "⏳",
        message: "Windows Update en cours... vos attaques sont mélangées !",
        effect: { type: "shuffle_moves" },
        reactions: {
          attack: "Tu attaques. ÉCRAN BLEU. « Windows applique des mises à jour, ne pas éteindre. » Tes options sont chamboulées.",
          defense: "Tu te défends. Le système se met à jour pendant ta défense. Tes formulaires sont mélangés.",
          heal: "Tu te soignes. Update incrémentielle de 4,7 Go. Pendant ce temps, tes choix se brouillent.",
        },
      },
      {
        name: "Timeout de session",
        damage: 20,
        emoji: "⌛",
        message: "Votre session a expiré après 2h de formulaire.",
        reactions: {
          attack: "Tu attaques. Au moment où tu valides : « Session expirée ». Tu perds tout. Tout tout.",
          defense: "Tu te défends. La session expire pendant que tu protèges tes données. Personne n'a sauvegardé.",
          heal: "Tu te soignes. Le timer atteint zéro. Le formulaire de soins est annulé pour cause d'inactivité.",
        },
      },
    ],
    introDiag: "Chargement en cours... ... ... Erreur : veuillez reessayer ulterieurement.",
    defeatDiag: "FATAL ERROR : boss.exe a cesse de fonctionner.",
    loot: { name: "Capture d'Ecran Preuve", emoji: "\ud83d\udcf8", image: "/images/items/loot_bug_info.png", effect: "luck", value: 5, desc: "+5 LUCK -- Tu as la preuve que ca marchait pas" },
    color: "cyan"
  },
  {
    id: "courrier_caf",
    name: "Le Courrier Recommandé de la CAF",
    emoji: "\u2709\ufe0f",
    title: "Boss Final -- AR N\u00b02C 047 892 3741 2",
    description: "Il est arrive un samedi. Personne n'etait pret.",
    hp: 280, maxHp: 280,
    atk: 18, def: 10,
    attacks: [
      {
        name: "Trop-perçu de 3 247€",
        damage: 25,
        emoji: "💸",
        message: "La CAF veut récupérer 3 247€. T'as 30 jours.",
        reactions: {
          attack: "Tu attaques. L'enveloppe craque, libère un avis : « 3 247€. Sous 30 jours. Pas de discussion. »",
          defense: "Tu te défends. Une rafale de chiffres rouges traverse ta défense. Trois mille deux cent quarante-sept.",
          heal: "Tu te soignes. Le montant à rembourser augmente de 47€ pour frais de relance.",
        },
      },
      {
        name: "Suspension des droits",
        damage: 30,
        emoji: "🚫",
        message: "Tes droits sont suspendus. Tu peux plus te soigner.",
        effect: { type: "disable_heal", turns: 2 },
        reactions: {
          attack: "Tu attaques. La CAF répond en suspendant tes droits. Tes soins ne fonctionnent plus.",
          defense: "Tu te défends. L'enveloppe scelle ta carte vitale. Tu ne peux plus rien soigner.",
          heal: "Tu te soignes. Trop tard : tes droits sont suspendus rétroactivement. Le soin est annulé.",
        },
      },
      {
        name: "Courrier en double",
        damage: 15,
        emoji: "📨",
        message: "Le même courrier arrive 2 fois. La prochaine attaque est doublée.",
        effect: { type: "next_double" },
        reactions: {
          attack: "Tu attaques. Deux exemplaires identiques de l'enveloppe te tombent dessus. La suite va piquer.",
          defense: "Tu te défends. Le courrier arrive en double — ta défense ne couvre que le premier.",
          heal: "Tu te soignes. Le facteur sonne. Encore. Avec le même recommandé. La prochaine va doubler.",
        },
      },
      {
        name: "Convocation obligatoire",
        damage: 12,
        emoji: "📅",
        message: "Convocation le 32 février à 6h du matin.",
        effect: { type: "debuff_def", value: 5 },
        reactions: {
          attack: "Tu attaques. L'enveloppe te tend une convocation impossible. Ta défense baisse rien que d'y penser.",
          defense: "Tu te défends. La convocation arrive : 32 février, 6h du matin. Ta logique vacille.",
          heal: "Tu te soignes. La convocation t'arrive : « Présence obligatoire — sous peine de radiation. »",
        },
      },
      {
        name: "Menace de saisie",
        damage: 35,
        emoji: "⚖️",
        message: "ULTIME ! L'huissier est en route !",
        isCrit: true,
        chance: 0.2,
        reactions: {
          attack: "ULTIME ! Tu attaques sans relâche. Le huissier sonne à la porte. Trop tard.",
          defense: "ULTIME ! Tu te défends comme tu peux. L'huissier passe par la fenêtre. Tu n'es pas chez toi en sécurité.",
          heal: "ULTIME ! Tu te soignes — l'huissier en profite pour saisir ta cafetière, ton frigo et ton chat.",
        },
      },
    ],
    introDiag: "RECOMMANDE AVEC ACCUSE DE RECEPTION. Objet : Regularisation de votre situation.",
    defeatDiag: "Votre dossier est desormais... a jour. *bruit de tampon*",
    loot: { name: "Attestation CAF Definitive", emoji: "\ud83c\udfc6", image: "/images/items/loot_courrier_caf.png", effect: "all", value: 10, desc: "+10 TOUT -- Le Graal administratif" },
    color: "red"
  }
];
